<template>
    <b-modal :id="modalId" :title="title" size="xl" ok-only ok-title="Tutup">
        <div v-if="files.length > 1" class="d-flex flex-wrap gap-2 mb-3">
            <b-button
                v-for="file in files"
                :key="file.url"
                size="sm"
                :variant="file.url === url ? 'pgiBtn' : 'outline-primary'"
                @click="$emit('switch-photo', file)"
            >
                {{ file.label }}
            </b-button>
        </div>
        <template v-if="url">
            <div v-if="isImage === null" class="text-center my-3">
                <b-spinner small />
            </div>
            <a v-else-if="isImage" :href="url" target="_blank" rel="noopener noreferrer" class="preview-file-image-link">
                <img :src="url" class="preview-file" alt="Preview Foto" />
            </a>
            <iframe
                v-else
                :src="url"
                class="preview-file"
                title="Preview Foto"
            />
        </template>
        <p v-else class="mb-0">File tidak tersedia.</p>
    </b-modal>
</template>

<script>
export default {
    name: "modal-kas-kecil-log-photo-preview",
    props: {
        modalId: { type: String, default: "modal-preview-log-kas-kecil" },
        title: { type: String, default: "" },
        url: { type: String, default: "" },
        files: { type: Array, default: () => [] },
    },
    data() {
        return {
            isImage: null,
        }
    },
    watch: {
        url: {
            immediate: true,
            handler(newUrl) {
                this.detectFileType(newUrl)
            },
        },
    },
    methods: {
        detectFileType(url) {
            this.isImage = null
            if (!url) return

            const probe = new Image()
            probe.onload = () => { this.isImage = true }
            probe.onerror = () => { this.isImage = false }
            probe.src = url
        },
    },
}
</script>

<style scoped>
.preview-file {
    border: 0;
    height: 75vh;
    width: 100%;
}

img.preview-file {
    object-fit: contain;
}

.preview-file-image-link {
    display: block;
}
</style>
